import createTransition from 'shared-tokens/utils/createTransition';
import colors from 'shared-tokens/utils/tokens/colors';
import spacings from 'shared-tokens/utils/tokens/spacings';
import shadows from 'shared-tokens/utils/tokens/shadows';
import tp from 'shared-tokens/utils/tokens/typography';
import { bordersR } from 'shared-tokens/utils/tokens/borders';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');

export const mainCls = 'autocmp-field';

const styleSel = {
    boxShadow: '2px 2px 8px 0 rgba(105, 118, 132, 0.5)',
    borderRadius: bordersR.m,
    backgroundColor: colors.w.rgba,
};

const hlStyleGoogle = {
    borderLeft: '4px solid #697684 !important',
}


export default {
    [mainCls]: {
        position: 'relative',
    },

    [`${mainCls}__input`]: {
        position: 'relative',
        zIndex: 1,
    },

    [`${mainCls}__items`]: {
        overflow: 'auto',
        maxHeight: 48 * 4,
    },

    [`${mainCls}__items-wrap`]: {
        width: '100%',
        border: '1px solid',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        boxShadow: `4px 4px 6px -1px ${shadows.shadowColor.rgba}`,
        marginTop: -1,
        position: 'relative',
        zIndex: 3,
    },

    [`${mainCls}__items--no-h`]: {
        maxHeight: '100%',
    },

    [`${mainCls}__items--abs`]: {
        position: 'absolute',
        top: 40,
        left: 0,
    },

    [`${mainCls}__item`]: {
        padding: spacings.s,
        color: colors.f3.rgba,
    },

    [`${mainCls}__item--hl`]: {
        background: colors.bg.rgba,
    },

    [`${mainCls}__item-inn`]: {
        padding: spacings.s,
        pointerEvents: 'none',
    },

    [`${mainCls}__item-inn--sel`]: styleSel,
    [`${mainCls}__item-inn--hl`]: styleSel,
    [`${mainCls}__item-inn--l11`]: {
        margin:`0 ${spacings.m}px`,
        padding: '0 28px 0 20px',
        border: 'none !important',
        '&.autocmp-field__item-inn--hl': {
            '&:before': {
                left: '14px',
            },
            '&:after': {
                left:'14px',
            },
        },
        '&.autocmp-field__item-inn': {
            border: 'none',
            marginRight: '24px',
            '&:before': {
                content:'""',
                position: 'absolute',
                top:0, 
                left:'2px',
                width:'1px',
                height:'100%',
                background:'#96a1b0',
            },
            '&.lst-l11': {
                '&:before': {
                    height:'50%',
                }
            },
            '&:after': {
                content:'""',
                position: 'absolute',
                top:'50%',  
                left:'2px',
                width:'10px',
                height:'1px',
                background:'#96a1b0',
            }, 
        },
    },

    [`${mainCls}__empty-state`]: {
        fontFamily: tp.tpFonts.m,
        fontSize: tp.tpSizes.l,
        color: colors.f3.rgba,
        textAlign: 'center',
        padding: spacings.s,
    },
    [`${mainCls}__pwrd-google`]: {
        content: '',
        height: '30px',
        boxSizing: 'border-box',
        textAlign: 'right',
        display: 'block',
        padding: '8px',
        backgroundImage: 'url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png)',
        backgroundPosition: 'right 8px center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '120px 14px',
        backgroundColor: '#fff',
    },
    [`${mainCls}__canc-btn`]: {
        width: 0,
        overflow: 'hidden',
        textAlign: 'right',
        willChange: 'width',
        transition: createTransition(['width']),
    },
    [`${mainCls}__canc-btn--s`]: {
        width: 65,
    },
    [`${mainCls}__cnt-google__item-inn--hl`]: {
        ...hlStyleGoogle,
    },
    'cnt-btn-google-hl': {
        [brpM]: {
            marginLeft: '-4px',
        },
    },
    'theme-border': {
        [`& .${mainCls}__items`]: {
            maxHeight: '280px',
        },
        [`& .${mainCls}__item`]: {
            padding: 0,
        },
        [`& .${mainCls}__item-inn`]: {
            borderLeft: '4px solid transparent',
            padding: '18px',
            paddingLeft: spacings.m,
        },
        [`& .${mainCls}__item-inn--hl`]: {
            boxShadow: 'none',
            borderRadius: 0,
            borderColor: colors.f2.rgba,
        },
    },
}